export const ROUTE_STRING = {
  LIST_APP: {
    LIST: '/apps',
    DETAIL: '/apps/:appId/overview',
    EDIT: '/apps/:appId/edit',
    EDIT_FEATURE: '/apps/:appId/edit-feature',
  },
  CREATE_APP: '/create-app',
  DOCKER_IMAGE: {
    LIST: '/docker-images',
    ADD: '/docker-images/add',
    VIEW: '/docker-images/:repository',
    UPGRADE_VERSION: '/docker-images/:repository/upgrade-version',
    LOG: '/docker-images/:lastRunId/logs',
  },
  APP_PACKAGE: {
    LIST: '/app-packages',
    ADD: '/app-packages/add',
    VIEW: '/app-packages/:id',
  },
  APP_INSTANCE: {
    LIST: '/app-instances',
    ADD: '/app-instances/add',
    VIEW: '/app-instances/:id',
  },
  CONTAINER_APP: {
    VIEW: '/container-app/:appInstanceId/:id',
  },
  IDP_CLIENT: {
    LIST: '/idp-clients',
  },
};
